import api from '../utils/api';

const examOfficeService = {
  // Question bank
  listQuestions: (params = {}) => api.get('/api/exam-papers/question-bank', { params }),
  createQuestion: (data) => api.post('/api/exam-papers/question-bank', data),
  updateQuestion: (id, data) => api.put(`/api/exam-papers/question-bank/${id}`, data),
  deleteQuestion: (id) => api.delete(`/api/exam-papers/question-bank/${id}`),

  // Exam papers
  listPapers: (params = {}) => api.get('/api/exam-papers', { params }),
  createPaper: (data) => api.post('/api/exam-papers', data),
  getPaper: (id) => api.get(`/api/exam-papers/${id}`),
  updatePaper: (id, data) => api.put(`/api/exam-papers/${id}`, data),
  deletePaper: (id) => api.delete(`/api/exam-papers/${id}`),
  addQuestionToPaper: (paperId, data) => api.post(`/api/exam-papers/${paperId}/questions`, data),
  removeQuestionFromPaper: (paperId, linkId) => api.delete(`/api/exam-papers/${paperId}/questions/${linkId}`),
  submitPaper: (id) => api.post(`/api/exam-papers/${id}/submit`),
  approvePaper: (id, data = {}) => api.post(`/api/exam-papers/${id}/approve`, data),
  rejectPaper: (id, data = {}) => api.post(`/api/exam-papers/${id}/reject`, data),

  // Components + marks
  listComponents: (scheduleId) => api.get(`/api/exam-marks/schedules/${scheduleId}/components`),
  createComponent: (scheduleId, data) => api.post(`/api/exam-marks/schedules/${scheduleId}/components`, data),
  updateComponent: (id, data) => api.put(`/api/exam-marks/components/${id}`, data),
  deleteComponent: (id) => api.delete(`/api/exam-marks/components/${id}`),
  upsertMarks: (componentId, marks) => api.post(`/api/exam-marks/components/${componentId}/marks/bulk`, { marks }),
  listComponentMarks: (componentId) => api.get(`/api/exam-marks/components/${componentId}/marks`),
  listStudentMarks: (studentId) => api.get(`/api/exam-marks/students/${studentId}/marks`),

  // Remark requests
  listRemarkRequests: (params = {}) => api.get('/api/exam-remarks', { params }),
  createRemarkRequest: (data) => api.post('/api/exam-remarks', data),
  cancelRemarkRequest: (id) => api.post(`/api/exam-remarks/${id}/cancel`),
  reviewRemarkRequest: (id, data) => api.post(`/api/exam-remarks/${id}/review`, data),

  // Malpractice cases
  listMalpracticeCases: (params = {}) => api.get('/api/malpractice-cases', { params }),
  createMalpracticeCase: (data) => api.post('/api/malpractice-cases', data),
  getMalpracticeCase: (id) => api.get(`/api/malpractice-cases/${id}`),
  updateMalpracticeCase: (id, data) => api.patch(`/api/malpractice-cases/${id}`, data),
};

export default examOfficeService;
